import { defineRecipe } from '@chakra-ui/react';
import { defaultVariant } from '@theme/variants/textarea/default.variant';

export const textareaRecipe = defineRecipe({
  base: {
    width: '100%',
    padding: 2,
    rounded: 'none',
    border: '2px solid',
  },
  variants: {
    variant: {
      default: defaultVariant,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
